import type { ConfirmationOptions } from '@/app/contexts/confirmation.context'

export const getPublishConfirmation = () => ({
  title: 'Set campaign live?',
  content: (
    <>
      After setting the campaign live you will be able to subscribe contacts to it and use it for inbound messages and
      calls.
      <br />
      <br />
      <strong>Warning: Once this campaign goes live, it cannot be returned to draft.</strong>
    </>
  ),
  confirmButtonLabel: 'Set Live',
})

export const getAbortConfirmation = (campaignName: string) => ({
  title: <>Warning - Stopping "{campaignName}"</>,
  content: (
    <>
      Stopping this campaign cannot be undone. All existing subscriptions will be stopped and any message that has not
      been sent yet will be canceled.
      <br />
      <b>Please confirm that's what you want to do.</b>
    </>
  ),
  confirmButtonLabel: 'Stop the campaign',
})

export const getUnsubAllConfirmation = (campaignName: string) => ({
  title: (
    <>
      Unsubscribe all contacts in <b>"{campaignName}"</b>
    </>
  ),
  content: (
    <>
      Stopping all in progress subscriptions will end the subscription for all contacts who are in the middle of this
      campaign (this includes live and scheduled subscriptions).
      <br />
      They will not receive any more calls, messages, or top-ups. No more actions will execute.
      <br />
      However, ongoing calls will continue to their natural end (we won't hang up on contacts who are in the middle of a
      call).
      <br />
      <b>Please confirm that you want to do this.</b>
    </>
  ),
  confirmButtonLabel: 'Confirm',
})

export const getUnsavedChangesConfirmation = (onDiscard: () => void): ConfirmationOptions => ({
  additionalButtonLabel: 'Discard Changes and Exit',
  title: 'Unsaved changes',
  content: (
    <>
      You have unsaved changes to this campaign. Select Save and Exit to save your changes before leaving, or Return to
      campaign to continue editing. If you leave without saving, your changes will be lost.
    </>
  ),
  cancelButtonLabel: 'Return to campaign',
  confirmButtonLabel: 'Save and Exit',
  onAdditionalClick: onDiscard,
})

export const getChatbotUnsavedChangesConfirmation = (onDiscard: () => void): ConfirmationOptions => ({
  additionalButtonLabel: 'Discard and exit',
  title: 'Unsaved changes',
  content:
    'You may have unsaved changes. If you made changes, please return to the campaign and click Save at the bottom of the page. Otherwise, you will lose any changes you made.',
  hideCancel: true,
  confirmButtonLabel: 'Return to campaign',
  onAdditionalClick: onDiscard,
})
